module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/49155458334f57d91193a2a347c23311.png";